module.exports = __webpack_public_path__ + "static/ng_orange_group_2-7cfa04f0bd831dcb049c27eaa5ac7aad.png";